function formatMixName(mix) {
  return mix.name + (mix.visibility === 'private' ? ' (Private)' : '')
}

module.exports = {
  formatMixName
}
